import React from 'react';
import clsx from 'clsx';
import FunctionsBarCreateProject from './FunctionsBarCreateProject';
import GetStepContent from './GetStepContent';


function GetText(step,isEdit) {
  
    switch (step) {
      case 0:
        return (
          <div>
            <div className={clsx('boldBlue')} style={{ textAlign: 'center' }}>
              {isEdit !== true
                ? 'Welcome to the "New project" creation wizard.'
                : 'Welcome'}
            </div>
  
            <div className={clsx('lightBlue')} style={{ textAlign: 'center' }}>
              {isEdit !== true
                ? 'This wizard will help you build the basics for your project.'
                : 'This wizard will help you to edit the basics for your project'}
            </div>
          </div>
        );
      default:
        return (
          <div>
            <div className={clsx('boldBlue')} style={{ textAlign: 'center' }}>
              Summary
            </div>
          </div>
        );
    }
}


const GeneralBody = (props) => {

    const {
        isEdit
    } = props;

    const text = GetText(0,isEdit);
    const [lock,setLock] = React.useState(false);

    const [
        display,
        appName,
        description,
        typeApp,
        colorTheme,
        fontType,
        invitedlist,
        selectedDuplicatedProject
    ] = GetStepContent(0,isEdit);

    return(
        <div
            className={clsx('spacingTop')}
            style={{ padding: '0 20% 0 20%' }}
            >
          <div>
              <div >{text}</div>
              <div style={{marginTop: '2rem'}}>{display}</div>
          </div>
          <FunctionsBarCreateProject
              appName={appName}
              description={description}
              colorTheme={colorTheme}
              typeApp={typeApp}
              fontType={fontType}
              invitedlist={invitedlist}
              isEdit={isEdit}
              lock={lock}
              setLock={setLock}
              selectedDuplicatedProject={selectedDuplicatedProject}
          />
        </div>
    )

}

export default GeneralBody;